var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payouts"},[_c('Pane',[_c('h1',[_vm._v(_vm._s(_vm.$t('profile.myPayouts')))]),_c('DataGrid',{attrs:{"data":_vm.getPayouts,"model":_vm.payoutsModel}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }